<template>
  <div id="nosotros" class="page-section">
    <!-- SECCION "NOSOTROS" -->
    <b-container class="container py-3">
      <b-row class="py-5 justify-content-center" align-h="center">
        <h2 class="section-title">Nosotros</h2>
      </b-row>
      <b-row class="justify-content-center">
        <b-col class="col-sm-10">
          <p class="lead paragraph-text">
            <strong> JFS Transporta, Transportes Temperaturas Controladas S.A de C.V Y Transportes Temperaturas Controladas LLC</strong>
            son empresas del área de transporte con más de 50 años de experiencia y presencia en la República Mexicana y Estados Unidos.
          </p>
        </b-col>
      </b-row>

      <b-row class="justify-content-center">
        <b-col sm md="3" class="text-center mt-3">
          <b-button v-b-modal.modal-mission class="px-3 btn-block" pill size="lg" variant="primary">Misión</b-button>
       </b-col>
        <b-col sm md="3" class="text-center mt-3">
          <b-button v-b-modal.modal-vision class="px-3 btn-block" pill size="lg" variant="primary">Visión</b-button>
        </b-col>
      </b-row>

      <b-row class="mt-5">
        <b-col class="text-center">
          <img src="../assets/Snowflake.png" alt="Snowflake" style="width:10vh">
        </b-col>
      </b-row>
    </b-container>

    <b-modal id="modal-mission" title="Misión" size="lg" header-bg-variant="primary" header-text-variant="light" hide-footer>
      <p class="my-4">Garantizar la satisfacción de nuestros clientes, brindando un servicio de calidad, eficiencia y eficacia en todas nuestras entregas nacionales e internacionales, manteniendo la cadena de frío desde origen a destino, preservando la seguridad del cargamento con entregas en tiempo y forma.</p>
    </b-modal>
    <b-modal id="modal-vision" title="Visión" size="lg" header-bg-variant="primary" header-text-variant="light" hide-footer>
      <p class="my-4">Ser empresa líder en transporte terrestre de productos refrigerados a nivel internacional, reconocida por sus altos estándares de calidad, seguridad e higiene. Posicionarnos en el ranking como mejor lugar para trabajar; Consolidarnos como empresa socialmente responsable.</p>
    </b-modal>

  </div>
</template>

<style scoped>
#nosotros{
  background-color: #f4f4f4;
}
.section-title {
  font-size: 48px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.1em;
}
.paragraph-text {
  font-size: 24px;
  text-align: justify;
}

.page-section {
  padding-bottom: 4rem;;
}
@media only screen and (max-width: 500px){
  .paragraph-text{
    font-size: 20px;
    padding-left: 10px;
    padding-right: 10px;
  }
  .section-title{
    font-size: 40px;
  }
  .page-section{
    padding-bottom: 2rem;
  }
}
</style>

<script>
export default {
  name: 'Nosotros'
}
</script>
